import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'
import { makeApiCall } from './makeApiCall'
import {
  FETCH_GROUP_DATA_REQUEST,
  FETCH_GROUP_DATA_SUCCESS,
  FETCH_GROUP_DATA_FAILURE,
  UPDATE_DISCOUNT_GROUP_REQUEST,
  UPDATE_DISCOUNT_GROUP_SUCCESS,
  UPDATE_DISCOUNT_GROUP_FAILURE
} from './types'

//pgm List Action  
export const pgmListAction = (params, page, search = '', fromDate, toDate, selectedRemarks, selectedExecutiveId) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  let url = `${API_URL}${Url.PGM_LIST}/${params}?page=${page}&page_size=15`;

  if (search) {
    url += `&search_data=${search}`;
  }

  if (fromDate) {
    url += `&from_date=${fromDate}`;
  }

  if (toDate) {
    url += `&to_date=${toDate}`;
  }

  if (selectedRemarks) {
    url += `&remark=${selectedRemarks}`;
  }

  if (selectedExecutiveId) {
    url += `&area_executive_id=${selectedExecutiveId}`;
  }

  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp?.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_PGM_LIST, payload: resp })
      return resp
    } else {
      return null;
    }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// Searched data
export const searchinputAction = (params = {}) => dispatch => {
  dispatch({ type: types.PGM_SEARCH_DATA, payload: params ? { data: params } : null })
}

// pgmlist Page
export const pageinputAction = (params = {}) => dispatch => {
  dispatch({ type: types.PGM_PAGE_VALUE, payload: params ? params : null })
}

// pgmlist Button Filter
export const pgmFilterButtonAction = (params = {}) => dispatch => {
  dispatch({ type: types.PGM_FILTER_BUTTON_VALUE, payload: params ? params : null })
}

//pgm Detail   
export const pgmdetailAction = (parms) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.PGM_DETAIL + "/" + parms
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_PGM_DETAIL, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//pgm Roles Get API   
export const pgmRolesAction = () => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.PGM_ROLES
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp?.status === 200 || resp?.status === 201) {
      dispatch({ type: types.GET_PGM_ROLES, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//User Approval
export const approvalAction = (params = {}, id) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.USER_APPROVAL + "/" + id
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_USER_APPROVAL, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

//User Deactivate
export const userDeactiveAction = (id) => dispatch => {
  const url = Url.USER_DEACTIVATE + "/" + id
  let options = Object.assign({ method: HTTP_METHOD.POST })
  options.headers = getHeaders()
  const API_URL = localStorage.getItem('countryBackendUrl')
  options.url = API_URL + url
  return axiosInstance(options).then(response => {
    if (response.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.POST_USER_DEACTIVATE, payload: response })
      return response
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// Need Correction
export const needCorrectionAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.NEED_CORRECTION
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_NEED_CORRECTION, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// Get Group Data
export const fetchGroupAction = () => async (dispatch) => {
  const endpoint = Url.GET_GROUP_DATA;
  return makeApiCall({
    method: 'GET',
    endpoint,
    dispatch,
    requestType: FETCH_GROUP_DATA_REQUEST,
    successType: FETCH_GROUP_DATA_SUCCESS,
    failureType: FETCH_GROUP_DATA_FAILURE,
  });
};

// Update Discount Group
export const updateDiscountGroup = (userId, discountGroupId) => async (dispatch) => {
  const url = Url.UPDATE_DISCOUNT_GROUP(userId)
  return await makeApiCall({
    method: "PATCH",
    endpoint: url,
    data: {
      discount_group_id: discountGroupId,
    },
    dispatch,
    requestType: UPDATE_DISCOUNT_GROUP_REQUEST,
    successType: UPDATE_DISCOUNT_GROUP_SUCCESS,
    failureType: UPDATE_DISCOUNT_GROUP_FAILURE,
  });
};